export const defaultSettings = (slideIndex, afterSlide) => {
  return {
    cellAlign: 'center',
    slidesToShow: 2,
    slideIndex,
    afterSlide,
    cellSpacing: 40,
    renderBottomCenterControls: null,
    renderCenterLeftControls: null,
    renderCenterRightControls: null,
  };
};

export const mobileDevicesSettings = (slideIndex, afterSlide) => {
  return {
    cellAlign: 'center',
    slideIndex,
    afterSlide,
    renderCenterLeftControls: null,
    renderCenterRightControls: null,
    renderBottomCenterControls: null,
    wrapAround: true,
    cellSpacing: -45,
  };
};
